import { render, staticRenderFns } from "./PageLogin.vue?vue&type=template&id=2aa5a33f&scoped=true&"
import script from "./PageLogin.vue?vue&type=script&lang=ts&"
export * from "./PageLogin.vue?vue&type=script&lang=ts&"
import style0 from "./PageLogin.vue?vue&type=style&index=0&id=2aa5a33f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5a33f",
  null
  
)

export default component.exports